import { PropsWithChildren, useEffect } from 'react'
import { Intercom, LiveChatLoaderProvider } from 'react-live-chat-loader'
import { useRouter } from 'next/router'

import { useCustomerInfo } from 'hooks/useCustomerInfo'

export const IntercomProvider = ({ children }: PropsWithChildren): JSX.Element => {
  const router = useRouter()
  const { customerInfo } = useCustomerInfo()

  useEffect(() => {
    const handleRouteChange = () => {
      // @ts-ignore
      if (typeof window !== 'undefined') {
        // @ts-ignore
        window.intercomSettings = {
          // @ts-ignore
          app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID ?? '',
          user_id: customerInfo?.customer?.id,
          name: customerInfo?.customer?.fullName,
          email: customerInfo?.organization?.email ?? customerInfo?.customer?.email,
          created_at: customerInfo?.customer?.createdAt,
          company: customerInfo?.organization
            ? {
                company_id: customerInfo?.organization?.id,
                name: customerInfo?.organization?.name,
                created_at: customerInfo?.organization?.createdAt,
              }
            : undefined,
        }
      }
    }

    router.events.on('routeChangeStart', handleRouteChange)

    // If the component is unmounted, unsubscribe
    // from the event with the `off` method:
    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [router.events])

  if (typeof window !== 'undefined') {
    // @ts-ignore
    window.intercomSettings = {
      // @ts-ignore
      app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID ?? '',
      user_id: customerInfo?.customer?.id,
      name: customerInfo?.customer?.fullName,
      email: customerInfo?.organization?.email ?? customerInfo?.customer?.email,
      created_at: customerInfo?.customer?.createdAt,
      company: customerInfo?.organization
        ? {
            company_id: customerInfo?.organization?.id,
            name: customerInfo?.organization?.name,
            created_at: customerInfo?.organization?.createdAt,
          }
        : undefined,
    }
  }

  return (
    <LiveChatLoaderProvider
      providerKey={process.env.NEXT_PUBLIC_INTERCOM_APP_ID ?? ''}
      provider="intercom"
      idlePeriod={0}
    >
      {children}

      <Intercom color="#FF8E00" />
    </LiveChatLoaderProvider>
  )
}
